module.exports = __webpack_public_path__ + "img/cardbg-3.449689e1.jpeg";